import { useQuery } from "@tanstack/react-query";
import { AxiosInstance } from "./auth/AxiosInstance";

export const useGetHellocianProjects = (type = 'all') => {
    return useQuery({
        queryKey: ['hellocian-projects', type],
        queryFn: async () => {
            // type can be 'sales' to get orders where user is seller/hellocian
            const response = await AxiosInstance.get(`/orders?type=sales`);
            return response.data.orders;
        },
        staleTime: 30000,
    });
};
